export type SuggestionType = {
  title: string
  description: string
  website_id: number[]
  action: SuggestionActionType
  additional_data: SuggestionsAdditionalDataType
  priority: SuggestionsPriorityEnum
  count: number
}

export type SuggestionActionType = {
  text: string
  type: SuggestionActionTypeEnum
  object_type: SuggestionActionObjectEnum
  filters?: Record<string, string | number>
}

export enum SuggestionActionTypeEnum {
  NAVIGATE = 'navigate',
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum SuggestionActionObjectEnum {
  PATIENT_JOURNEYS = 'patient_journeys',
  CLIENTS = 'clients',
  SUGGESTIONS = 'suggestions',
}

type SuggestionsAdditionalDataType = {
  count: number
  priority: SuggestionsPriorityEnum
  [key: string]: string | number
}

export enum SuggestionsPriorityEnum {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}
